import React, { Component } from 'react'
import ItemList from '../../../../../containers/Sections/Propiedades/List/propertyList'

export default class List extends Component {

  render () {

    const { properties } = this.props

    if (!properties){
      return (
        <div className='hoteles-container list-view'>
        no hay propiedades, ocurrio algun error
        </div>
      )
    }
    else{
      return (
        <div className='hoteles-container list-view'>
          <div className='container'>
            {properties.map((item, index) =>
              <ItemList property={item} key={index}/>
            )}
          </div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/PropiedadesList/List/index.js